/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Hero_LedeInputs */

const en_contact_hero_lede = /** @type {(inputs: Contact_Hero_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A question, a bug, an idea. It reaches the team that builds Complete Athlete, not a bot.`)
};

const pl_contact_hero_lede = /** @type {(inputs: Contact_Hero_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pytanie, błąd, pomysł. Trafi do zespołu, który buduje Complete Athlete, a nie do bota.`)
};

/**
* | output |
* | --- |
* | "A question, a bug, an idea. It reaches the team that builds Complete Athlete, not a bot." |
*
* @param {Contact_Hero_LedeInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const contact_hero_lede = /** @type {((inputs?: Contact_Hero_LedeInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Hero_LedeInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_contact_hero_lede(inputs)
	return en_contact_hero_lede(inputs)
});